import React from 'react'
import styled from '@emotion/styled'

// Import Components
import { FooterView } from './FooterView'

// Styled Components via Emotion
const FooterWrapper = styled.footer`
	height: 100%;
	width: 100%;

	* {
		box-sizing: content-box !important;
	}
`

/**
 * This Component is the Footer
 * This is global, and not dynamic
 * Takes in the FooterView component so we can pass the theme props
 * On Desktop: all the links should be laid out
 * On Mobile: all the links are grouped up into drawers
 */
export function Footer() {
	return (
		<FooterWrapper id="footer">
			<FooterView />
		</FooterWrapper>
	)
}
